import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import type { Attachment } from '@/shared/stores/create-entity-store'
import type {
  NotificationItem,
  NotificationListGroup,
  NotificationErrorData,
  NotificationPermission,
} from './types'

interface NotificationsState {
  notificationLists: NotificationListGroup[]
  notifications: NotificationItem[]
  totalUnreadMessages: number
  totalNotifications: number
  errorData: NotificationErrorData
  permission: NotificationPermission
  attachments: Attachment[]
  total: number
  page: number
  size: number
  isLoading: boolean

  setNotificationLists: (list: NotificationListGroup[]) => void
  setNotifications: (notifications: NotificationItem[]) => void
  setTotalUnreadMessages: (count: number) => void
  setTotalNotifications: (count: number) => void
  setPermission: (permission: NotificationPermission) => void
  setTotal: (total: number) => void
  setPage: (page: number) => void
  setSize: (size: number) => void
  setLoading: (loading: boolean) => void
  reset: () => void
}

export const useNotificationsStore = create<NotificationsState>()(
  immer((set) => ({
    notificationLists: [],
    notifications: [],
    totalUnreadMessages: 0,
    totalNotifications: 0,
    errorData: {} as NotificationErrorData,
    permission: {} as NotificationPermission,
    attachments: [],
    total: 0,
    page: 0,
    size: 20,
    isLoading: false,

    setNotificationLists: (list) => set((s) => { s.notificationLists = list }),
    setNotifications: (notifications) => set((s) => { s.notifications = notifications }),
    setTotalUnreadMessages: (count) => set((s) => { s.totalUnreadMessages = count }),
    setTotalNotifications: (count) => set((s) => { s.totalNotifications = count }),
    setPermission: (permission) => set((s) => { s.permission = permission }),
    setTotal: (total) => set((s) => { s.total = total }),
    setPage: (page) => set((s) => { s.page = page }),
    setSize: (size) => set((s) => { s.size = size }),
    setLoading: (loading) => set((s) => { s.isLoading = loading }),
    reset: () =>
      set((s) => {
        s.notificationLists = []
        s.notifications = []
        s.totalUnreadMessages = 0
        s.totalNotifications = 0
        s.errorData = {} as NotificationErrorData
      }),
  }))
)
